import { render } from "./Choice.vue?vue&type=template&id=f5df8654&scoped=true&ts=true"
import script from "./Choice.vue?vue&type=script&lang=ts"
export * from "./Choice.vue?vue&type=script&lang=ts"

import "./Choice.vue?vue&type=style&index=0&id=f5df8654&lang=scss&scoped=true"

import exportComponent from "/var/www/widget.surveybot.me/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5df8654"]])

export default __exports__